// Mock data for Elite Gold Transfers - Lisbon

export const company = {
  name: "Elite Gold Transfers",
  short: "Elite Gold",
  tagline: "Transfers & Tours",
  phone: "+351 963 196 242",
  phoneRaw: "+351963196242",
  whatsapp: "351963196242",
  email: "geral.elitegoldtransfers@gmail.com",
  domain: "elitegoldtransfers.com",
  address: "Lisboa, Portugal"
};

export const services = [
  {
    id: 1,
    title: "Airport Transfers",
    titlePt: "Transferências Aeroporto",
    description: "Comfortable and reliable airport transfers to and from Lisbon Airport",
    descriptionPt: "Transferências confortáveis e confiáveis de e para o Aeroporto de Lisboa",
    icon: "plane",
    features: ["24/7 Availability", "Flight Tracking", "Meet & Greet", "Fixed Prices"]
  },
  {
    id: 2,
    title: "City Tours",
    titlePt: "Tours pela Cidade",
    description: "Discover Lisbon's historic neighborhoods, monuments and hidden gems",
    descriptionPt: "Descubra os bairros históricos, monumentos e segredos de Lisboa",
    icon: "map",
    features: ["Expert Guides", "Flexible Schedule", "Small Groups", "Local Insights"]
  },
  {
    id: 3,
    title: "Private Tours",
    titlePt: "Tours Privados",
    description: "Customized private tours tailored to your interests and schedule",
    descriptionPt: "Tours privados personalizados aos seus interesses e horários",
    icon: "users",
    features: ["Custom Itinerary", "Personal Guide", "Premium Vehicles", "VIP Service"]
  },
  {
    id: 4,
    title: "Day Trips",
    titlePt: "Viagens de Um Dia",
    description: "Explore Sintra, Cascais, Óbidos and other beautiful destinations",
    descriptionPt: "Explore Sintra, Cascais, Óbidos e outros destinos maravilhosos",
    icon: "compass",
    features: ["Full Day Tours", "Multiple Destinations", "Lunch Included", "Photo Stops"]
  }
];

// Service tiers (Low Cost / Luxury)
export const serviceTiers = [
  {
    id: "lowcost",
    name: "Low Cost",
    namePt: "Low Cost",
    price: "25",
    route: "Airport → City",
    routePt: "Aeroporto → Cidade",
    description: "Reliable, comfortable transfers at the best value for your trip.",
    descriptionPt: "Transferências fiáveis e confortáveis ao melhor preço para a sua viagem.",
    features: ["Comfortable sedan", "Up to 3 passengers", "Meet & greet", "Fixed price, no surprises"],
    featuresPt: ["Sedan confortável", "Até 3 passageiros", "Receção personalizada", "Preço fixo, sem surpresas"],
    featured: false
  },
  {
    id: "luxury",
    name: "Luxury",
    namePt: "Luxury",
    price: "35",
    route: "Airport → City",
    routePt: "Aeroporto → Cidade",
    description: "A premium chauffeur experience in a high-end vehicle with VIP treatment.",
    descriptionPt: "Uma experiência premium com motorista, veículo topo de gama e tratamento VIP.",
    features: ["Premium Mercedes class", "Professional chauffeur", "Bottled water & WiFi", "Priority meet & greet"],
    featuresPt: ["Mercedes classe premium", "Motorista profissional", "Água e WiFi a bordo", "Receção VIP prioritária"],
    featured: true
  },
  {
    id: "van",
    name: "Van",
    namePt: "Van",
    price: "65",
    route: "Airport → City",
    routePt: "Aeroporto → Cidade",
    description: "Spacious executive van, ideal for families and larger groups with extra luggage.",
    descriptionPt: "Van executiva espaçosa, ideal para famílias e grupos maiores com bagagem extra.",
    features: ["Executive van", "Up to 7 passengers", "Extra luggage space", "Meet & greet"],
    featuresPt: ["Van executiva", "Até 7 passageiros", "Espaço extra para bagagem", "Receção personalizada"],
    featured: false
  }
];

export const vehicles = [
  {
    id: 1,
    name: "Sedan",
    capacity: "1-3 passengers",
    capacityPt: "1-3 passageiros",
    luggage: "3 bags",
    luggagePt: "3 malas",
    image: "https://images.pexels.com/photos/8425380/pexels-photo-8425380.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    features: ["Air Conditioning", "WiFi", "Water", "Phone Charger"]
  },
  {
    id: 2,
    name: "Executive Van",
    capacity: "4-7 passengers",
    capacityPt: "4-7 passageiros",
    luggage: "7 bags",
    luggagePt: "7 malas",
    image: "https://images.pexels.com/photos/17455633/pexels-photo-17455633.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    features: ["Leather Seats", "WiFi", "Water", "Entertainment System"]
  },
  {
    id: 3,
    name: "Minibus",
    capacity: "8-15 passengers",
    capacityPt: "8-15 passageiros",
    luggage: "15 bags",
    luggagePt: "15 malas",
    image: "https://images.unsplash.com/photo-1570125909232-eb263c188f7e?w=800&q=80",
    features: ["Group Travel", "WiFi", "Water", "Spacious Interior"]
  }
];

export const tours = [
  {
    id: 1,
    name: "Lisbon Highlights",
    namePt: "Destaques de Lisboa",
    duration: "4 hours",
    durationPt: "4 horas",
    price: "€45",
    description: "Visit Belém Tower, Jerónimos Monastery, and ride the iconic Tram 28",
    descriptionPt: "Visite a Torre de Belém, Mosteiro dos Jerónimos e ande no icónico Elétrico 28",
    image: "https://images.unsplash.com/photo-1585208798174-6cedd86e019a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxsaXNib24lMjB0cmFtJTIwMjh8ZW58MHx8fHwxNzgwODY1MTM2fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    name: "Sintra & Cascais",
    namePt: "Sintra e Cascais",
    duration: "8 hours",
    durationPt: "8 horas",
    price: "€75",
    description: "Explore fairy-tale palaces in Sintra and coastal beauty of Cascais",
    descriptionPt: "Explore palácios de contos de fadas em Sintra e a beleza costeira de Cascais",
    image: "https://images.pexels.com/photos/5511316/pexels-photo-5511316.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 3,
    name: "Fado Night Experience",
    namePt: "Noite de Fado",
    duration: "3 hours",
    durationPt: "3 horas",
    price: "€55",
    description: "Authentic Fado music experience with dinner in Alfama",
    descriptionPt: "Experiência autêntica de Fado com jantar em Alfama",
    image: "https://images.unsplash.com/photo-1598948485421-33a1655d3c18?w=800&q=80"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Maria Santos",
    country: "USA",
    rating: 5,
    text: "Excellent service! Our driver was punctual, professional and very knowledgeable about Lisbon. Highly recommend!",
    textPt: "Serviço excelente! Nosso motorista foi pontual, profissional e muito conhecedor de Lisboa. Recomendo!"
  },
  {
    id: 2,
    name: "John Smith",
    country: "UK",
    rating: 5,
    text: "The Sintra tour was absolutely amazing. Our guide made the experience unforgettable. Worth every euro!",
    textPt: "O tour de Sintra foi absolutamente incrível. Nosso guia tornou a experiência inesquecível. Vale cada euro!"
  },
  {
    id: 3,
    name: "Sophie Martin",
    country: "France",
    rating: 5,
    text: "Best transfer service in Lisbon. Clean vehicles, friendly drivers, and great prices. Will use again!",
    textPt: "Melhor serviço de transfer em Lisboa. Veículos limpos, motoristas simpáticos e ótimos preços. Usarei novamente!"
  }
];

export const pricing = [
  {
    id: 1,
    from: "Airport ⇄ City Center",
    fromPt: "Aeroporto ⇄ Centro",
    lowcost: "€25",
    luxury: "€35",
    van: "€65"
  },
  {
    id: 2,
    from: "Lisbon ⇄ Sintra",
    fromPt: "Lisboa ⇄ Sintra",
    lowcost: "€35",
    luxury: "€55",
    van: "€70"
  },
  {
    id: 3,
    from: "Lisbon ⇄ Cascais",
    fromPt: "Lisboa ⇄ Cascais",
    lowcost: "€35",
    luxury: "€55",
    van: "€70"
  }
];

// Accepted payment methods
export const paymentMethods = [
  { id: "card", label: "Credit / Debit Card", labelPt: "Cartão de Crédito / Débito", icon: "credit-card" },
  { id: "sumup", label: "SumUp Payment Link", labelPt: "Link de Pagamento SumUp", icon: "link" },
  { id: "transfer", label: "Bank Transfer", labelPt: "Transferência Bancária", icon: "bank" },
  { id: "mbway", label: "MB Way", labelPt: "MB Way", icon: "smartphone" },
  { id: "cash", label: "Cash", labelPt: "Dinheiro", icon: "banknote" }
];

// Long-distance / intercity transfers
export const longTrips = [
  {
    id: 1,
    route: "Lisbon ⇄ Algarve",
    routePt: "Lisboa ⇄ Algarve",
    duration: "~2h45",
    description: "Door-to-door comfort all the way to the southern beaches.",
    descriptionPt: "Conforto porta-a-porta até às praias do sul."
  },
  {
    id: 2,
    route: "Lisbon ⇄ Porto",
    routePt: "Lisboa ⇄ Porto",
    duration: "~3h00",
    description: "Travel north in comfort to the beautiful city of Porto.",
    descriptionPt: "Viaje para norte com conforto até à bela cidade do Porto."
  },
  {
    id: 3,
    route: "Lisbon ⇄ Seville",
    routePt: "Lisboa ⇄ Sevilha",
    duration: "~4h30",
    description: "Cross-border private transfer to Seville, Spain — and back.",
    descriptionPt: "Transfer privado transfronteiriço até Sevilha, Espanha — e regresso."
  },
  {
    id: 4,
    route: "Anywhere in Portugal & Spain",
    routePt: "Qualquer destino em Portugal e Espanha",
    duration: "Custom",
    description: "Tell us your route — we arrange long-distance day trips anywhere.",
    descriptionPt: "Diga-nos a sua rota — organizamos viagens longas para qualquer destino."
  }
];

// Build a pre-filled WhatsApp message/link with booking details (free instant notification)
export const buildWhatsAppLink = (data, ref) => {
  const lines = [
    `Nova reserva Elite Gold${ref ? ` (${ref})` : ''}`,
    data.name && `Nome: ${data.name}`,
    data.phone && `Telefone: ${data.phone}`,
    data.email && `Email: ${data.email}`,
    data.service && `Serviço: ${data.service}`,
    data.date && `Data: ${data.date}`,
    data.pickup && `Recolha: ${data.pickup}`,
    data.destination && `Destino: ${data.destination}`,
    data.passengers && `Passageiros: ${data.passengers}`,
    data.notes && `Notas: ${data.notes}`
  ].filter(Boolean);
  const text = encodeURIComponent(lines.join('\n'));
  return `https://wa.me/${company.whatsapp}?text=${text}`;
};

// Submit booking / quote to the backend
export const submitBooking = async (bookingData) => {
  const API = process.env.REACT_APP_BACKEND_URL;
  const res = await fetch(`${API}/api/bookings`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(bookingData)
  });
  if (!res.ok) throw new Error('Booking request failed');
  const data = await res.json();
  return { success: true, bookingId: data.reference };
};

// Mock function to simulate contact form submission
export const submitContact = (contactData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true });
    }, 1000);
  });
};
